import { jsx as g } from "react/jsx-runtime";
import { withManagedProps as b } from "@made-people/managed-props";
import { z as a } from "zod";
import { withZod as y } from "@made-people/react-prop-guard";
import { responsiveImageSchema as j, ResponsiveImage as V } from "@made-people/blueprint-responsive-image";
import { responsiveVideoSchema as N, ResponsiveVideo as S } from "@made-people/blueprint-responsive-video";
import { mediaBlueprint as p } from "./index-blueprint.es.js";
import x from "clsx";
import "@made-people/blueprint";
const M = a.object({
  variants: a.custom().optional(),
  className: a.string().optional(),
  video: N.optional(),
  image: j.optional(),
  width: a.object({
    initial: a.object({
      value: a.number().optional()
    }).optional(),
    md: a.object({
      value: a.number().optional()
    }).optional(),
    lg: a.object({
      value: a.number().optional()
    }).optional()
  }).optional()
}), W = b(
  "Media",
  y(M, (e) => {
    var s, n, r;
    const d = p.styles(e.variants);
    function f(i) {
      var c, v, u;
      const o = {};
      let t = "";
      return ((c = i == null ? void 0 : i.initial) == null ? void 0 : c.value) !== void 0 && (o["--w-initial"] = `${i.initial.value}%`, t += " w-[var(--w-initial)]"), ((v = i == null ? void 0 : i.md) == null ? void 0 : v.value) !== void 0 && (o["--w-md"] = `${i.md.value}%`, t += " md:w-[var(--w-md)]"), ((u = i == null ? void 0 : i.lg) == null ? void 0 : u.value) !== void 0 && (o["--w-lg"] = `${i.lg.value}%`, t += " lg:w-[var(--w-lg)]"), { widthVars: o, widthClasses: t.trim() };
    }
    const l = f(e.width), m = x(d.base, e.className, l.widthClasses);
    return e.video && e.video.src ? /* @__PURE__ */ g(
      S,
      {
        ...e.video,
        className: m,
        style: {
          ...l.widthVars,
          ...e.video.style
        }
      }
    ) : (s = e.image) != null && s.initial && ((n = e.image.initial) != null && n.src) || e.image && ((r = e.image.image) != null && r.src) ? /* @__PURE__ */ g(
      V,
      {
        ...e.image,
        className: m,
        style: {
          ...l.widthVars,
          ...e.image.style
        }
      }
    ) : null;
  })
);
export {
  W as Media,
  M as mediaSchema
};
//# sourceMappingURL=index.es.js.map
